import { render, staticRenderFns } from "./openEcology.vue?vue&type=template&id=46796b93&scoped=true&"
import script from "./openEcology.vue?vue&type=script&lang=js&"
export * from "./openEcology.vue?vue&type=script&lang=js&"
import style0 from "./openEcology.vue?vue&type=style&index=0&id=46796b93&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46796b93",
  null
  
)

export default component.exports